import React, {useState, useEffect} from 'react';

import Slider from 'react-slick';
import SoldIcon from '../sold-icon';
import StatusIcon from '../status-icon/status-icon';
import ListingFeedback from '../listing-feedback/listing-feedback';
import Modal from '../modal';
import UserForm from '../user-form';
import HOne from '../h-one';

import ThanksModal from '../thanks-modal';
import ListingHeader from '../listing-page/components/listing-header';
import ListingMedia from '../listing-page/components/listing-media';
import DealScoreContactForm from '../listing-page/components/deal-score-contact-form';
import DealScore from '../deal-score';
import KeyDealFeatures from '../key-deal-features';

import StringProcessingService from '../../services/string-processing-service';
import ConfigurationService from '../../services/configuration-service';

function OfferResaleModal(props) {
   
    const configurationService = new ConfigurationService();
    const stringProcessingService = new StringProcessingService();

    let { 
        data,
        countSilderImg = 4,
        dealScore = true,
        dictionary, 
        width, 
        projectData, 
        internalLink = true,
        height,
        agent = null,
        country,
        isVisible,
        setIsVisible,
    } = props;

    let analyseInfo = null;
    if(data.Analyse) analyseInfo = data.Analyse;


    // const [isVisible, setIsVisible] = useState(false);
    const [isVisibleThanksModal, setIsVisibleThanksModal] = useState(false);
    const [currentImgId, setCurrentImgId] = useState(false);
    const [currentImg, setCurrentImg] = useState(false);
    // const [contactInfo, setContactInfo] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(false);


    let userComment ='';

    if(data.BedroomsTotal > 1){
        userComment = dictionary.resale_listing_comment_multiple
        .replace('[bedrooms_total]',parseInt(data.BedroomsTotal))
      
    }else if(data.BedroomsTotal == 1){
        userComment = dictionary.resale_listing_comment
        .replace('[bedrooms_total]',parseInt(data.BedroomsTotal))
    }else{
        userComment = dictionary.resale_listing_comment_studio;
    }

    let parsedPrice = stringProcessingService.convertToFormat(data.ListPrice.toString());

    
    userComment = userComment.replace('[project_name]', projectData.name)
    userComment = userComment.replace('[list_price]', parsedPrice)

    const initForm  = {
        userFullName: '',
        userPhone: '',
        userEmail: '',
        userMessage: '',
        userComment: userComment,
        project: 'MLS ' + data.Id
    }

    const [contactForm, setContactForm] = useState(initForm);




    const handleDealScore = () => {
        let keyDealFeatures = document.getElementsByClassName('KeyDealBlock')[0];
        keyDealFeatures.scrollIntoView({ block: "center", behavior: "smooth" });
    }


    const handleInput = (event) => {
        setContactForm({
            ...contactForm,
            [event.target.name]: event.target.value
        })
    }

    const closeModal = () => {
        setIsVisibleThanksModal(false);
    }


    const openThanksModal = (event) => {
        setIsVisible(false)
        setIsVisibleThanksModal(true);
    }

    const handleSwitchMedia = (newImage) => {
        setCurrentImgId(newImage.Order);
        setCurrentImg(newImage.MediaUrl);
    }

    const clearForm = () => {
        setContactForm(initForm)
    }

    const saveCurrentSelectedCountry = (value) => {
        setSelectedCountry(value);
    }
    return (
        <>
             <Modal
                        ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
                        closeModal={()=>{setIsVisible(false)}}
                        modalClass={'MessageModal OfferResaleModal'}
                        hiddenCloseIcon={true}
                        closeColor={'#fff'}
                        speed={0.5}
                        ModalStyle={{ justifyContent: 'center', flexDirection: 'column', padding: "0", alignItems: 'center', display:'block', whiteSpace: 'wrap' }}
                        isVisible={isVisible}
                        >

                    <div className="ListinPageBody" >
                        <ListingHeader
                            data = {data}
                            dictionary = {dictionary}
                            project = {projectData}
                            width = {width}
                            analyseInfo = {analyseInfo}
                            handleDealScore = {handleDealScore}
                        />
                        <div className={"PageListingLine"}>
                            <div className="PageListing">
                                <ListingMedia
                                    dictionary = {dictionary}
                                    width = {width}
                                    height= {height}
                                    analyseInfo= {analyseInfo}
                                    agent = {agent}
                                    handleDealScore= {handleDealScore}
                                    country = {country}
                                    contactInfo = {contactForm}
                                    selectedCountry = { selectedCountry}
                                    saveCurrentSelectedCountry = {saveCurrentSelectedCountry}
                                    handleInput = {handleInput}
                                    clearForm = {clearForm}
                                    openThanksModal = {(openThanksModal)}
                                    handleSwitchMedia = {handleSwitchMedia}
                                    currentImgId = {currentImgId}
                                    currentImg = {currentImg}
                                    data = {data}
                                    disableModal={true}
                                />

                                <div className="ListingPageMainInfoDiv">
                                    <KeyDealFeatures
                                        dictionary={dictionary}
                                        analyseInfo={analyseInfo}
                                        data={data}
                                        width={width}
                                    />

                               
                                </div>
                               <div className='ResaleMobileForm'>
                                    <div className='DealScoreAndContacts'>
                                        <DealScore
                                            dictionary={dictionary}
                                            width={width}
                                            analyseInfo={analyseInfo}
                                            handleDealScore={handleDealScore}
                                        />
                                        <DealScoreContactForm
                                            dictionary={dictionary}
                                            width={width}
                                            country={country}
                                            contactInfo={contactForm}
                                            selectedCountry={selectedCountry}
                                            agent={agent}
                                            analyseInfo={analyseInfo}
                                            data={data}
                                            saveCurrentSelectedCountry={saveCurrentSelectedCountry}
                                            handleInput={handleInput}
                                            clearForm={clearForm}
                                            openThanksModal={openThanksModal}
                                        />
                                    </div>
                               </div>
                        </div>
                    </div>
                    
                  
                    
                  
                </div>
                    
                </Modal>
                    <ThanksModal
                    isVisible={isVisibleThanksModal}
                    title={dictionary.thank_you}
                    message={dictionary.thank_you_deal}
                    closeModal={closeModal}
                />

        </>
    )
}

export default OfferResaleModal;